import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { UiLegacy } from "@silvertours/front-legacy-shared";
import { ReviewContainer, ReviewFooter, QuoteContainer, ColoredText } from "./Reviews.styles";
import { ReviewHeader } from "./ReviewHeader";
import { useReviewItem } from "./useReviewItem";
var LargeReviewItem = function(props) {
    var providerQuote = props.providerQuote, siteQuote = props.siteQuote;
    var ref = useReviewItem(props), header = ref.header, providersQuoteTitleLabel = ref.providersQuoteTitleLabel, reviewerLabel = ref.reviewerLabel, siteQuoteTitleLabel = ref.siteQuoteTitleLabel;
    return /*#__PURE__*/ _jsxs(ReviewContainer, {
        largeReview: true,
        children: [
            /*#__PURE__*/ _jsx(ReviewHeader, _object_spread({}, header)),
            /*#__PURE__*/ _jsxs(QuoteContainer, {
                children: [
                    /*#__PURE__*/ _jsx(UiLegacy.PlainText, {
                        children: /*#__PURE__*/ _jsx(ColoredText, {
                            children: siteQuoteTitleLabel
                        })
                    }),
                    /*#__PURE__*/ _jsx(UiLegacy.Quote, {
                        children: siteQuote
                    }),
                    /*#__PURE__*/ _jsx(UiLegacy.PlainText, {
                        children: /*#__PURE__*/ _jsx(ColoredText, {
                            children: providersQuoteTitleLabel
                        })
                    }),
                    /*#__PURE__*/ _jsx(UiLegacy.Quote, {
                        children: providerQuote.quote
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ReviewFooter, {
                children: /*#__PURE__*/ _jsx(UiLegacy.PlainText, {
                    children: reviewerLabel
                })
            })
        ]
    });
};
export { LargeReviewItem };
